import type {
  PartnerPlugin,
  PartnerParams,
  PartnerAuthPayload
} from '@/types/partner'

import { pickEmail, pickSlug } from '../utils'

const DoityPlugin: PartnerPlugin = {
  id: 'doity',
  name: 'Doity',
  match: (params: PartnerParams) => {
    if (
      params.source === 'query' &&
      (params.raw['partner'] === 'doity' || params.raw['partner_id'] === 'doity')
    )
      return true
    if (params.referer && params.referer.includes('doity.com')) return true
    if (params.ua && params.ua.includes('DoityWebView')) return true
    return false
  },
  getAuthPayload: (params: PartnerParams): PartnerAuthPayload | null => {
    const slug = params.slug || pickSlug(params.raw, params.digitalProductId)
    if (!slug) return null

    const id = (params.raw['id'] || params.raw['doity_id'] || '').trim()
    const email = params.email || pickEmail(params.raw)
    if (!id || !email) return null

    const token = JSON.stringify({
      id,
      email,
      name: params.raw['name']
        ? decodeURIComponent(params.raw['name'])
        : undefined,
      phone: params.raw['phone'],
      cpf: params.raw['cpf']
    })

    return { provider: 'doity', token }
  }
}

export default DoityPlugin
